import { Badge } from '@mantine/core';

import classes from './badge.module.css';

export const BadgeOverride = Badge.extend({
  classNames: classes,
  defaultProps: { radius: 'sm' },
});
